import {
    createSlice,
    createAsyncThunk,
    createEntityAdapter,
} from '@reduxjs/toolkit'
import { client } from '../../api/client'

const devicesAdapter = createEntityAdapter({
    selectId: x => x.Id
})

const initialState = devicesAdapter.getInitialState({
    status: 'idle',
    error: null,
})

export const fetchDevices = createAsyncThunk('devices/Get', async () => {
    const response = await client.get('/Devices')
    return response.data
})

const devicesSlice = createSlice({
    name: 'devices',
    initialState,
    reducers: {},
    extraReducers: {
        [fetchDevices.pending]: (state, action) => {
            state.status = 'loading'
            state = undefined
        },
        [fetchDevices.fulfilled]: (state, action) => {
            state.status = 'succeeded'
            devicesAdapter.addMany(state, action.payload)
        },
        [fetchDevices.rejected]: (state, action) => {
            state.status = 'failed'
            state.error = action.payload
        }
    },
})

export default devicesSlice.reducer

export const {
    selectAll: selectAllDevices,
    selectById: selectDevicesById,
} = devicesAdapter.getSelectors((state) => state.devices)
